export enum documentsTypeEnum {
  IndividualTaxNumber,
  IdCard,
  Passport,
  MedicalReference,
  CategoryBDrivingLicense
}
